<template>
	<v-container class="pa-0" v-if="currentIndexRetailer !== -1">
		<associate-card
			v-if="currentRetailer[currentIndexRetailer - 1]"
			:associateData="currentRetailer[currentIndexRetailer - 1]"
			:isFixed="true"
			@GO_BACK="goBack"
			:jeet11Color="jeet11Color"
			:rummyColor="rummyColor"
		/>
		<v-container
			:style="{
				paddingTop: currentIndexRetailer > 0 ? '150px' : 0
			}"
		>
			<infinite-scroll
				:items="retailersData[currentIndexRetailer].list"
				:offset="retailersData[currentIndexRetailer].offset"
				:currentRetailer="currentRetailer[currentIndexRetailer - 1]"
				:selfUserId="userId"
				:jeet11Color="jeet11Color"
				:rummyColor="rummyColor"
				:loading="isDataLoading"
				@ON_CLICK="fetchRetailerChild"
				@GO_BACK="goBack"
			/>
			<h6
				class="text-center mt-4"
				v-if="retailersData[currentIndexRetailer].list.length === 0"
			>
				No Associates under this User
			</h6>
		</v-container>
		<div v-if="isDataLoading" class="overlay">
			<v-progress-circular :indeterminate="true"></v-progress-circular>
		</div>
	</v-container>
</template>
<script>
import { mapState } from "vuex";
import { FETCH_RETAILER_CHILD } from "../../store/action-types";
import { RUMMY_COLOUR, THEME_INPUT_COLOUR } from "../constants";
import AssociateCard from "./AssociateCard.vue";
import InfiniteScroll from "./InfiniteScroll.vue";
import EventsManager from "@/event-manager";

export default {
	name: "MyAssociates",
	data: () => ({
		jeet11Color: THEME_INPUT_COLOUR,
		rummyColor: RUMMY_COLOUR,
		retailersData: [],
		currentIndexRetailer: -1,
		currentRetailer: [],
		showAssociatesDialog: false,
		isDataLoading: false
	}),
	components: {
		"associate-card": AssociateCard,
		"infinite-scroll": InfiniteScroll
	},
	mounted() {
		this.fetchRetailerChild({ userId: this.userId });
		EventsManager.sendEvent({
			name: "MY_ASSOCIATES_TAB_OPENED",
			properties: {
				userId: this.userId,
				type: this.storeType,
				actionUserId: "myAssociates"
			}
		});
	},
	methods: {
		fetchRetailerChild(item) {
			if (this.isDataLoading) {
				return;
			}
			this.isDataLoading = true;
			this.$store
				.dispatch(FETCH_RETAILER_CHILD.dispatch, {
					userId: item.userId,
					offset: item.offset
				})
				.then(data => {
					const { retailerChildDetails, nextOffset } = data.response;
					if (item.offset) {
						this.retailersData[this.currentIndexRetailer].list.push(
							...retailerChildDetails
						);
						this.retailersData[
							this.currentIndexRetailer
						].offset = nextOffset;
					} else {
						this.retailersData.push({
							list: retailerChildDetails || [],
							offset: nextOffset
						});
						if (this.currentIndexRetailer !== -1) {
							this.currentRetailer.push(item);
							EventsManager.sendEvent({
								name: "MY_ASSOCIATES_TAB_OPENED",
								properties: {
									userId: this.userId,
									type: this.storeType,
									actionUserId: item.userId
								}
							});
						}
						this.currentIndexRetailer++;
					}
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isDataLoading = false;
				});
		},
		goBack() {
			this.retailersData.pop();
			this.currentRetailer.pop();
			this.currentIndexRetailer--;
		}
	},
	computed: {
		...mapState({
			userId: state => state.auth.USERID,
			storeType: state => state.jeet11.jeet11PartnerDetails.userType
		})
	}
};
</script>
<style lang="scss" scoped>
.overlay {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;
}
</style>
